import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ReduxProvider, { store } from "./store/provider";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Add an event listener to capture clicks on any element
// document.addEventListener("click", function () {
//   // Scroll the page to the top
//   window.scrollTo(0, 0);
// });

root.render(
  <React.StrictMode>
    <ReduxProvider store={store}>
      <App />
    </ReduxProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
